// extracted by mini-css-extract-plugin
export default {"rentalForm":"_2tfg-e5tFZUdus3hHRkpWO"};